export interface EnumOptions {
  label: string;
  color?: 'danger' | 'warn' | 'success' | 'none' | 'primary' | 'info';
  icon?: 'times' | 'exclamation' | 'check' | 'minus' | 'info';
}

export const createEnumOptions = <T extends string | number | symbol>(values: {
  [key in T | '_default']: EnumOptions;
}) => new Map(Object.entries(values).map(([key, value]) => [key, value]));

export const createEnumOptionsBoolean = (values: {
  true?: EnumOptions;
  false?: EnumOptions;
  _default?: EnumOptions;
}) => new Map(Object.entries(values).map(([key, value]) => [key, value]));

export const createEnumList = (
  createEnumOptions: Map<string, EnumOptions>,
  omitDefault = true,
  parseNumberKey = true,
) => {
  const result: { label: string; value: unknown }[] = [];

  for (const [key, value] of createEnumOptions) {
    if (omitDefault && key === '_default') {
      continue;
    }

    result.push({
      value: parseNumberKey
        ? isNaN(parseInt(key))
          ? key
          : parseInt(key)
        : key,
      label: value.label,
    });
  }
  return result;
};

export const filterEnumOptions = <K, V>(
  options: Map<K, V>,
  filterFn: (label: K, value: V) => boolean,
) => {
  return new Map<K, V>(
    [...options.entries()].filter(([label, value]) => filterFn(label, value)),
  );
};

export const swaggerEnumDescription = (
  options: Map<string, { label: string }> | string[],
  desc?: string,
) => {
  return [...options.entries()].reduce(
    (acc, [key, value]) => {
      let row = '';
      if (typeof value === 'string') {
        row = `
        ${value}`;
      } else {
        row = `
      ${key} - ${value.label}`;
      }
      if (key !== '_default') {
        return acc + row;
      }
      return acc;
    },
    desc
      ? `
    ${desc}\n`
      : '',
  );
};
